<template>
  <footer>
    <!-- HTML do footer -->
    <footer id="footer" class="footer dark-background">
      <div class="container footer-top">
        <div class="row gy-4">
          <div class="col-lg-4 col-md-6 footer-about">
            <a href="index.html" class="logo d-flex align-items-center">
              <span class="sitename">Incubator</span>
            </a>
            <div class="footer-contact pt-3">
              <p>Campus do Palmarejo Grande, C.P. 379-C</p>
              <p>Edifício 12, Sala 107 - Praia, Santiago, Cabo Verde</p>
              <p class="mt-3">
                <strong>Phone:</strong> <span>(+238) 3340 200</span>
              </p>
              <p>
                <strong>Email:</strong> <span>incubator22force@gmail.com</span>
              </p>
            </div>
            <div class="social-links d-flex mt-4">
              <a href=""><i class="bi bi-twitter-x"></i></a>
              <a href=""><i class="bi bi-facebook"></i></a>
              <a href=""><i class="bi bi-instagram"></i></a>
              <a href=""><i class="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div class="col-lg-2 col-md-3 footer-links">
            <h4>Links Úteis</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/projeto">Incubator</a></li>
              <li><a href="/saudemasculina">Saúde Masculina</a></li>
              <li><a href="/analisesclinicas">Análises Clínicas </a></li>
            </ul>
          </div>

          <div class="col-lg-2 col-md-3 footer-links">
            <h4>Parceiros</h4>
            <ul>
              <li>
                <a href="https://www.han.gov.cv/">Hospital Agostinho Neto</a>
              </li>
              <li>
                <a href="https://uem.mz/">Universidade Eduardo Mondlane</a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/HospitalCentraldeMaputo/?locale=pt_BR"
                  >Maputo Central Hospital</a
                >
              </li>
            </ul>
          </div>
          <!-- HTML do footer -->
          <div class="col-lg-4 col-md-12 footer-map">
            <h4>Visite-nos</h4>

            <div
              style="
                border: 1px solid #ddd;
                border-radius: 10px;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              "
            >
              <a
                href="https://maps.app.goo.gl/tXNZKkDotJ58T2CAA"
                target="_blank"
                rel="noopener noreferrer"
                style="display: block; width: 100%; height: 100%"
              >
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.8337748578636!2d-23.55026638468229!3d14.924389350255458!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9359857c495d21d%3A0xfc3307650a7cdb00!2sUniversidade%20de%20Cabo%20Verde%20(Uni-CV)!5e0!3m2!1spt-CV!2scv!4v1694968000000!5m2!1spt-CV!2scv"
                  width="100%"
                  height="200"
                  style="border: 0"
                  allowfullscreen=""
                  loading="lazy"
                >
                </iframe>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="container copyright text-center mt-4">
        <p>
          ©2025 <span>Copyright </span> 
          <strong class="px-1 sitename">Incubator.</strong>
          <span>All Rights Reserved</span>
        </p>
        <div class="credits">
          Designed by <a href="#">Equipa INCUBATOR</a>
        </div>
      </div>
    </footer>
  </footer>
    <ChatFlutuante />
</template>

<script>
import ChatFlutuante from "../components/ChatFlutuante.vue";

export default {
  name: "AppFooter", // ou MeuFooter, FooterSection, etc
  components: { ChatFlutuante }
};
</script>

<style scoped>
/* Estilos do footer aqui */
</style>
